import { render, staticRenderFns } from "./motif-histoire.html?vue&type=template&id=940a52f6&scoped=true&external"
import script from "./motif-histoire.js?vue&type=script&lang=js&external"
export * from "./motif-histoire.js?vue&type=script&lang=js&external"
import style0 from "./motif-histoire.scss?vue&type=style&index=0&id=940a52f6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940a52f6",
  null
  
)

export default component.exports